/**
 * "How did you hear about us?" sources for signup.
 *
 * The LIVE list is editable by SuperAdmin and stored at
 * `platformConfig/signupOptions` (field: `heardFromOptions`). This array is only
 * the fallback/seed used when that doc is missing or can't be read (signup runs
 * pre-auth, so a read failure must never break the form).
 *
 * "Other" is always appended by the UI (it reveals a free-text box), so it is
 * intentionally NOT part of this list.
 */
export const DEFAULT_SIGNUP_SOURCES = [
  'WhatsApp',
  'Facebook / Instagram',
  'Google',
  'YouTube',
  'Reference',
];

export const OTHER_SOURCE = 'Other';
